module.exports = __webpack_public_path__ + "img/download-grey.37cb5520.svg";